export default {
  route: {
    home: '首页',
    myReward: '我的奖励',
    userPool: '用户池',
    rewardOrders: '奖励订单',
    distributorManagement: '分销商管理',
    rewardPackageConfig: '奖励套餐配置',
    distributorSettlement: '分销商结算',
    orderManagement: '管理订单',
    distributorApproval: '分销商审核',
    paymentManagement: '打款管理',
    paymentBillDetails: '打款账单详情'
  }
};